<template>
  <div class="pageBlock  container-fluid">
    <div class="entrySection">
      <div class="entrySectionImage">
        <slot name="entrySectionImage"></slot>
      </div>
      <div class="entrySectionText"><slot name="entrySectionText"></slot></div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style>
.pageBlock {
  display: flex;
  flex-direction: column;
  padding: 0 0 0 0;
}
.entrySection {
  overflow: hidden;
  text-align: center;
  color: #fff;
  position: relative;
}
.entrySectionImage {
  display: block;
  text-align: center;
}
.entrySectionText h3 {
  position: absolute;
  z-index: 1;
  width: 90%;
  top: 45%;
  left: 5%;
  color: #fff;
  opacity: 1;
  transition: 0.3s;
  font-size: 5vw;
}

@media (max-width: 800px) {
  .entrySectionText h3 {
    top: 35%;
    font-size: 7vw;
  }
}
</style>
